var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.className,attrs:{"href":("/angebote/" + (_vm.event.permalink)),"title":_vm.label,"aria-label":_vm.label}},[_vm._v("\n  Details\n")])}
var staticRenderFns = []

export { render, staticRenderFns }